<template>
  <div style="padding-top: 60px">
    <div class="header" style="position: fixed">
      <div class="header-left">
        <a @click="$router.back()" class="header-back"></a>
      </div>
      <div class="header-center">
        <a @click="$parent.goNav('/')" class="header-logo"> <img :src="$store.state.appInfo.site_logo || '/static/image/d11_logo_h5.png'" onerror="this.src = '/static/image/d11_logo_h5.png'" width="100%" /> </a>
        <h4 class="header-title hide"></h4>
      </div>
      <div class="header-right">
        <a @click="$parent.openKefu" id="gocs_btn" class="header-helper"></a>
        <a v-if="!$store.state.token" @click="$parent.goNav('/login')" class="header-action" id="login_btn" style="font-size: 12px">登录</a>
      </div>
    </div>
    <div class="mod-promotions activity-details mod-forms-3">
      <div class="promotions-detail">
        <img :src="dataInfo.banner" class="promotions-banner" onerror="this.style.display='none'" />
        <h3>{{ dataInfo.title }}</h3>
        <div class="promotions-content" style="box-sizing: border-box; padding: 10px; padding-bottom: 61px">
          <div v-html="dataInfo.content"></div>
          <div v-html="dataInfo.memo"></div>
        </div>
      </div>
    </div>
    <div class="promotions-state" style="">
      <span class="grey-btn" style="font-size: 16px; background: linear-gradient(63deg, #ff944b 0%, #fcc166 100%, #fcc166 100%)" @click="amountShow = true" v-if="$store.state.token && dataInfo.can_apply == 1">报名参与</span>
      <span @click="$parent.goNav('/login')" class="grey-btn" style="font-size: 16px; background: linear-gradient(63deg, #ff944b 0%, #fcc166 100%, #fcc166 100%)" v-else>登录后报名</span>
    </div>
        <!-- 填写申请金额 -->
     <van-dialog v-model="amountShow" title="活动申请" show-cancel-button :before-close="isOk" style="background: #fff !important" confirmButtonText="立即申请">
      <div style="padding: 10px;20px;background:rgb(251 248 248)!important">
        <van-cell-group>
          <van-field v-model="amount"  tyle="background:#fff!important" type="text" placeholder="请根据活动条件填写您能享受赠送的金额" oninput="value=value.replace(/[^0-9]/g,'')" />
        </van-cell-group>
      </div>
    </van-dialog>
  </div>
</template>
<script>
export default {
  name: 'activityInfo',
  data() {
    return { dataInfo: {}, amount: null, amountShow: false };
  },
  created() {
    let that = this;
    let query = that.$route.query;
    if (query.id) {
      that.getInfo(query.id);
    }
  },
  methods: {
    getInfo(id) {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun.post('/api/activitydeatil', { id }).then(res => {
        console.log(res);
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          that.dataInfo = res.data;
        }
        that.$parent.hideLoading();
      });
    },
    doactivityapply() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun.post('/api/doactivityapply', { activityid: that.dataInfo.id, amount: that.amount }).then(res => {
        that.$parent.hideLoading();
        that.$parent.showTost(1, res.message);
      });
    },
    isOk(action, done) {
      let that = this;
      if (action === 'confirm') {
        that.doactivityapply();
        done(true);
      } else {
        done(true);
      }
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
// @import '../../../static/css/announcement_modal.css';
* {
  margin: 0px;
  padding: 0px;
  list-style: none;
}

html,
body {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #0f9a70d2;
  background-size: cover;
}

#lxc_box {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
}

#lxc_conter {
  width: 1200px;
  height: 100%;
  margin: 0px auto;
}

#lxc_table {
  width: 1200px;
  background-color: rgba(27, 27, 27, 0.317);
  border-radius: 5px;
  padding: 10px;
  margin-top: 20px;
  box-sizing: border-box;
}

#al_table {
  text-align: center;
  width: 100% !important;
  background-color: #edf5ff;
}

#lxc_banner {
  width: 100%;
  /* height: 800px; */
  /* background: url(''); */
  background-size: 100%;
  opacity: 0.85;
}

.all_title1 {
  margin-top: -10px;
}

#lxc_banner img {
  width: 100%;
}

#lxc_hd {
  /* width: 100%; */
  /* margin-left: 10%; */
  /* height: 100px; */
  border: 1px solid rgba(90, 90, 90, 0.301);
  border-radius: 10px;
  background-image: linear-gradient(#ebde7e, #d89c46);
  position: relative;
  /* margin-top: 40px; */
  padding-bottom: 10px;
  top: -40px;
}

#lxc_hd ul {
  display: flex;
  width: 100%;
}

#lxc_hd ul li {
  width: 100%;
  margin-top: 10px;
  border-right: 1px solid rgb(72, 72, 72);
  text-align: center;
}

#lxc_hd ul li:last-child {
  border: none;
}

.lxc_hd_title {
  font-size: 1.6em;
  color: #2c2e2e;
  font-weight: 600;
}

.lxc_xg {
  margin-top: 10px;
}

#lxc_bott {
  width: 100%;
  font-size: 14px;
  line-height: 20px;
  margin-top: 5px;
  color: #fff;
}

.all_title {
  /* margin-top: 40px; */
  color: #fff;
  font-size: 30px;
  font-weight: 600;
}

.all_title2 {
  margin-top: 20px;
}

.b {
  display: none;
}

@media (max-width: 1300px) {
  #lxc_conter {
    width: 98%;
    /* margin-left: 5%; */
  }

  .all_title {
    margin-top: 20px;
  }

  .all_title1 {
    margin-top: -10px;
  }

  .lxc_table {
    margin-top: -10px;
  }

  #lxc_table {
    width: 100%;
  }

  .lxc_hd_title {
    font-size: 14px;
    color: #2c2e2e;
    font-weight: 600;
  }

  .lxc_xg {
    font-size: 12px;
  }
}

@media (max-width: 700px) {
  #lxc_hd {
    top: 0px;
    transition: all 0.2s;
  }

  .a {
    display: none;
  }

  .b {
    display: block;
  }

  .all_title1 {
    margin-top: 20px;
  }

  #lxc_hd ul li {
    margin: 2px;
  }

  #lxc_hd {
    border: none;
    padding: 2px;
  }

  .lxc_hd_title {
    position: relative;
    top: 2px;
  }

  .lxc_xg {
    position: relative;
    top: -5px;
  }

  #lxc_hd {
    border-radius: 5px;
  }
}

#al_table {
  border-width: 0px;
  border-image: initial;
  width: 100%;
  text-align: left;
  border-radius: 4px 4px 0px 0px;
  border-collapse: separate;
  border-spacing: 0px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  border-color: #1e1d1d initial initial #1e1d1d;
  border-style: solid initial initial solid;
}

#al_table tbody,
#al_table thead {
  border-collapse: separate;
  border-spacing: 0px;
  text-align: left;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: 'tnum';
  box-sizing: border-box;
}

#al_table tr {
  box-sizing: border-box;
  text-align: left;
  border-collapse: separate;
  border-spacing: 0px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: 'tnum';
}

#al_table tr td {
  border-width: 1px 1px 0px 0px;
  border-style: solid;
  border-color: #1e1d1d;
  padding: 16px 0;
  overflow-wrap: break-word;
  transition: all 0.3s ease 0s, border 0s ease 0s;
  word-break: break-word;
  box-sizing: border-box;
  border-collapse: separate;
  border-spacing: 0px;
  text-align: center;
  color: #ffffff;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: 'tnum';
  background-color: #0f9a71;
  font-weight: bold;
}

#al_table tbody tr td {
  background-color: #fff;
  font-weight: 500;
  color: #000;
}

#al_table thead tr td {
  border-color: #0f9a71;
}

.bz {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/activityInfo.vue